

















































import { Component, Vue } from 'vue-property-decorator'
import { ITuileNav } from '@/models/ui/ITuileNav'


@Component({
  name:"SectionInfosObj",
  components: {    
  },
  props:{    
    infosCol1:Array,
    infosCol2:Array,
    objectifs:Array
  }
})
export default class SectionInfosObj extends Vue {  
  infosCol1!:Array<string>
  infosCol2!:Array<string>
  objectifs!:Array<string> 
}
